import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Apollo } from 'apollo-angular';
import { firstValueFrom, Observable } from 'rxjs';
import { getIntitution, getTemplates } from './querys';

export class institucion {
  public templateIds?: Number[];
}

export class Settings {
  public name?: String;
  public value?: String;
}
@Injectable({
  providedIn: 'root'
})
export class InstitucionService {
  private apiURLadm = 'https://api-adminclient.rflatina.com/rfl/api/v1/';
  private apiURL = environment.apiURL_institucion;
    private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));
    
  constructor(
    private http: HttpClient,
    private cookies: CookieService,
    private readonly apollo: Apollo,
  ) { }

  public async getInstitucion(idInstitucion) {
    const { data } = await firstValueFrom(
      this.apollo.use(environment.apiURL_gestion).watchQuery<any>({
        query: getIntitution,
        context: {headers: this.headers},
        variables: {
          "institutionId": idInstitucion
        },
        fetchPolicy: 'no-cache'
      }).valueChanges
    );
    return data.institution;
  }
  public patchInstitucion(idInstitucion, templates): Observable<any> {
    const ar: institucion = {
      templateIds: templates.map(e => Number(e))
    }
    const body = JSON.stringify(ar);
    const apiURL = this.apiURL + "institucion/" + idInstitucion;
    return this.http.patch(`${apiURL}`, body, { headers: this.headers });
  }

  public postSettings(idIns: any): Observable<any> {
      const responsable: Settings = {
        name: 'false',
        value: '5',
      }
      const body = JSON.stringify(responsable);
      const apiURL = this.apiURL + "institucion/" + idIns + "/settings";
      return this.http.post(`${apiURL}`, body, { headers: this.headers });
  }
  public patchSettings(name: any, value: any, idSettings: any, idIns: any): Observable<any> {
    const responsable: Settings = {
      name: name + '',
      value: value + '',
    }
    const body = JSON.stringify(responsable);
    const apiURL = this.apiURL + "institucion/" + idIns + "/settings/" + idSettings;
    return this.http.patch(`${apiURL}`, body, { headers: this.headers });
  }

  public async getTemplates() {
    const { data } = await firstValueFrom(
      this.apollo.use(environment.apiURL_gestion).watchQuery<any>({
        query: getTemplates,
        context: {headers: this.headers},
        variables: {
          "args": {
            "pagination": {
              "isUnlimit": true
            }
          }
        },
        fetchPolicy: 'no-cache'
      }).valueChanges
    );
    return data.templates;
  }

  public getArchivosAdm(idInst): Observable<any> {
    const apiURL = this.apiURLadm + "files?id_company=" + idInst + "&folder=expediente ";
    return this.http.get(`${apiURL}`, { headers: this.headers });
  }
  public getArchivosA(idFile): Observable<any> {
    const apiURL = this.apiURLadm + "files/" + idFile;
    return this.http.get(`${apiURL}`, { headers: this.headers, 'responseType': 'arraybuffer' as 'json' });
  }
  public getInstitucionesAdmin(idInst){
    const apiURL = this.apiURLadm + `companies/${idInst}`;
    return this.http.get(`${apiURL}`, { headers: this.headers })
  }
}
